import { User } from 'oidc-client';
import { ApplicationState, NEiTThunk } from '..';
import notification from '../notification';
import { CoreActions } from './actionTypes';
import * as applicazioneApi from './api';
import { Anagrafica } from './models';
import { push, CallHistoryMethodAction } from 'connected-react-router'

type AuthenticationAction = CoreActions | CallHistoryMethodAction

export const loginSuccess = (user: User): NEiTThunk<void, AuthenticationAction> => (dispatch) => {
    dispatch({ type: 'core/LOGIN_SUCCESS', user });
    dispatch(push('/portal'));
}
export const logoutSuccess = (): NEiTThunk<void, AuthenticationAction> => (dispatch) => { 
    dispatch({ type: 'core/LOGOUT_SUCCESS' });
    dispatch(push('/'));
}

export const loginError = () : NEiTThunk<void, AuthenticationAction> => (dispatch) => {
    dispatch({ type: 'core/LOGIN_ERROR' });
    
    dispatch(push('/login'));
}
export const userExpired = () => ({ type: 'core/USER_EXPIRED' })

export const cambiaAnagrafica = () => ({ type: 'core/MODIFICA_ANAGRAFICA' })
export const anagraficaSelezionata = (anagrafica: Anagrafica) => ({ type: 'core/ANAGRAFICA_SELEZIONATA', value: anagrafica })

export const loadTenant = () : NEiTThunk<void, CoreActions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();

    applicazioneApi.getTenant(state)
        .then(tenant => {

            dispatch({ type: 'core/LOAD_TENANT', value: tenant });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const loadModuli = () : NEiTThunk<void, CoreActions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();

    applicazioneApi.getModuli(state)
        .then(moduli => {

            dispatch({ type: 'core/LOAD_MODULI', value: moduli });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const loadAnagrafiche = () : NEiTThunk<void, CoreActions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();
    const refreshCache: boolean = state.core.anagrafiche.refreshAnagrafiche;

    applicazioneApi.getAnagrafiche(state, refreshCache)
        .then(anagrafiche => {
            dispatch({ type: 'core/LOAD_ANAGRARICHE', value: anagrafiche });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

/*
export const actionCreators = {
    loginSuccess: (user: User): NEiTThunk<void, AuthenticationAction> => (dispatch) => {
        dispatch({ type: 'core/LOGIN_SUCCESS', user });
        dispatch(push('/portal'));
    },
    logoutSuccess: (): NEiTThunk<void, AuthenticationAction> => (dispatch) => { 
        dispatch({ type: 'core/LOGOUT_SUCCESS' });
        dispatch(push('/'));
    },
    loginError: () => ({ type: 'core/LOGIN_ERROR' }),
    userExpired: () => ({ type: 'core/USER_EXPIRED' }),

    cambiaAnagrafica: () => ({ type: 'core/MODIFICA_ANAGRAFICA' }),
    anagraficaSelezionata: (anagrafica: Anagrafica) => ({ type: 'core/ANAGRAFICA_SELEZIONATA', value: anagrafica }),

    loadTenant: () : NEiTThunk<void, CoreActions> => (dispatch, getState) => {
        dispatch({ type: 'core/BEGIN_AJAX_CALL' });

        const state: ApplicationState = getState();

        applicazioneApi.getTenant(state)
            .then(tenant => {

                dispatch({ type: 'core/LOAD_TENANT', value: tenant });
                dispatch({ type: 'core/END_AJAX_CALL' });
            })
            .catch(error => {
                dispatch({ type: 'core/END_AJAX_CALL' });
                notification.error(error.message);
            });
    },

    loadAnagrafiche: () : NEiTThunk<void, CoreActions> => (dispatch, getState) => {
        dispatch({ type: 'core/BEGIN_AJAX_CALL' });

        const state: ApplicationState = getState();
        const refreshCache: boolean = state.core.anagrafiche.refreshAnagrafiche;

        applicazioneApi.getAnagrafiche(state, refreshCache)
            .then(anagrafiche => {
                dispatch({ type: 'core/LOAD_ANAGRARICHE', value: anagrafiche });
                dispatch({ type: 'core/END_AJAX_CALL' });
            })
            .catch(error => {
                dispatch({ type: 'core/END_AJAX_CALL' });
                notification.error(error.message);
            });
    },
}*/